// dependencies
import { format, isAfter, isBefore, isValid, parseISO } from "date-fns";
import React from "react";

//components
import Button from "../../../../../../components/Button";
import TableChip from "../../../../../../components/Chip/templates/TableChip";
import { ScrollableColumn } from "../../../../../../components/TableLite/TableLiteScrollable/TableLiteScrollable";
import TruncatedText from "../../../../../../components/Text/TruncatedText";

//utils
import get from "../../../../../../utils/GetNested";

//css
import css from "../../../UserReviews.module.scss";

export const ReviewsOfMeTableCols = (easyAddEnabled = false): ScrollableColumn[] => {
	return [
		{
			id: "view",
			label: "",
			width: 96,
			isSortable: false,
			getter: (report) => (
				<Button href={`/view-review/${report._id}/`} color="blue">
					Open Review
				</Button>
			),
		},
		{
			id: "reviewName",
			label: "Review Name",
			isSortable: false,
			width: 640,
			getter: (review) => {
				let name = get(review, ["name"], null);
				const bulkReviewName = get(review, ["bulk_review", "name"], null);

				if (bulkReviewName && bulkReviewName.length > 0) {
					name = `${name} (Part of ${bulkReviewName})`;
				}

				let cell = <TruncatedText text={name} maxWidth={632} size="paragraph-3" weight="regular" />;

				if (easyAddEnabled) {
					const is360Enabled = get(review, ["360_count"], false);
					const isAwaitingApproval = get(review, ["awaiting_approval_count"], false);
					let maxWidth = 632;

					if (is360Enabled) {
						maxWidth -= 90;
					}
					if (isAwaitingApproval) {
						maxWidth -= 120;
					}
					cell = (
						<div className={css.nameWithChips}>
							<TruncatedText text={name} maxWidth={maxWidth} size="paragraph-3" weight="regular" />
							<div className={css.awaitingApprovalChips}>
								{is360Enabled ? <TableChip color="blue" label="360 Enabled" /> : null}
								{isAwaitingApproval ? <TableChip color="green" label="Awaiting Approval" /> : null}
							</div>
						</div>
					);
				}

				return cell;
			},
		},
		{
			id: "startDate",
			label: "Start Date",
			sortName: "start_date",
			width: 150,
			isSortable: true,
			getter: (report) => {
				const date = get(report, ["start_date"], null);
				// the maxkey is result in startdate reports
				// to be returned first so these should render null
				const parsedDate = parseISO(date);

				return isValid(parsedDate) ? format(parsedDate, "MMM d, yyyy hh:mm a") : null;
			},
		},
		{
			id: "status",
			isSortable: false,
			width: 140,
			label: "Status",
			getter: (review) => {
				const startDate = get(review, ["start_date"], null);
				const completed = get(review, ["completed"], false);

				const hasUnassignedReports = get(review, ["unassigned_report_form_count"], false);
				let status = "";

				const parsedDate = parseISO(startDate);
				if (completed) {
					status = "Completed";
				} else if (startDate && isAfter(parsedDate, new Date())) {
					status = hasUnassignedReports ? "Scheduled (Unassigned Forms)" : "Scheduled";
				} else if (startDate && isBefore(parsedDate, new Date())) {
					status = hasUnassignedReports ? "Active (Unassigned Forms)" : "Active";
				}
				return <TruncatedText text={status} maxWidth={134} size="paragraph-3" weight="regular" />;
			},
		},
	];
};

export default ReviewsOfMeTableCols;
